import { DiamondMultipleChoiceResultItem } from "./DiamondMultipleChoiceResultItem";

export default DiamondMultipleChoiceResultItem;